import React from "react";
import { StopOutlined } from "@ant-design/icons";

const EmptyState = ({ message, linkText, onClick,  fontWeight }) => (
  <div style={{ textAlign: "center", padding: "32px 16px" }}>
    <StopOutlined style={{ fontSize: 32, marginBottom: 12 }} />
    <div style={{ fontSize: 14, fontWeight: fontWeight  ? fontWeight : 400 }}>
      {message}{" "}
      {linkText && (
        <span onClick={onClick} style={{ textDecoration: "underline", cursor: "pointer" }}>
          {linkText}
        </span>
      )}
    </div>
  </div>
);

export default EmptyState;
